
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.63 20H.335V6.64h4.297V20zM2.632 4.61h-.03C1.224 4.61.334 3.585.334 2.303.335 1 1.249 0 2.655 0 4.06 0 4.92.992 4.952 2.304 4.95 3.586 4.06 4.61 2.632 4.61zM20.334 20h-4.297v-7.305c0-1.75-.625-2.945-2.18-2.945-1.187 0-1.89.803-2.203 1.586-.117.28-.148.664-.148 1.055V20H7.209V6.64h4.297V8.5c.625-.89 1.602-2.172 3.874-2.172 2.82 0 4.954 1.86 4.954 5.867V20z"}})])
          )
        }
      }
    